module.exports = __webpack_public_path__ + "static/media/ser5.aca7c467.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/services/ser5.jpg
// module id = 7071
// module chunks = 0